<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted mobile column -->
      <template #cell(mobile)="data">
        <span
          class="d-block"
          style="direction: ltr"
        >{{ data.value }}</span>
      </template>
      <!-- A custom formatted roles column -->
      <template #cell(roles)="data">
        <span class="font-weight-bold">
          {{ data.value.join(",") }}
        </span>
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('read', 'users')"
          variant="flat-info"
          size="sm"
          class="btn-icon rounded-circle"
          @click="$router.push({name:'users-show',params:{id:data.item.id}})"
        >
          <feather-icon icon="EyeIcon" />
        </b-button>
        <b-button
          v-if="$can('update', 'users')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'users')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no users to display") }}
      </h6>
    </div>
    <users-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import UsersEditModal from '../edit/UsersEditModal'

export default {
  name: 'UsersList',
  components: { UsersEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'users',
    }
  },
}
</script>

<style scoped>

</style>
